import React from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';
import Text from 'components/ui/text';
import View from 'components/ui/view';
import { withConjunction } from 'shared/utils';
import {
  isCompletedOrder,
  isActiveOrder,
  isCanceledOrder,
  isFailedOrder,
  isReturnedOrder,
  orderTotal
} from 'shared/models/order';

export default function OrderHistoryListItem({ order }) {
  const { order_date, products } = order;
  const fullOrderDate = moment(order_date).format('MMMM D, YYYY h:mm A');
  const briefOrderDate = moment(order_date).format('MMMM D, YYYY');

  const productTitles = (products || []).map(p => p.title);
  const productNames = withConjunction(productTitles);

  const canTip =
    !order.shipping &&
    isCompletedOrder(order) &&
    typeof order.order_rating === 'undefined' &&
    typeof order.order_tip === 'undefined';

  const canTrack = isActiveOrder(order);

  return (
    <View padding="sm" className="order-history-row">
      <div className="row middle-xs">
        <div className="col-xs-8 col-sm-9">
          <View margin="xxs">
            <Text
              secondary
              title
              size="sm"
              weight="med"
              className="text-overflow hidden-sm"
            >
              {briefOrderDate}
            </Text>
            <Text
              secondary
              title
              size="sm"
              weight="med"
              className="text-overflow visible-sm-block"
            >
              {fullOrderDate}
            </Text>
          </View>
          <div className="text-overflow">{productNames}</div>
        </div>

        <div className="col-xs-4 col-sm-3 text-right">
          <OrderLink
            canTip={canTip}
            canTrack={canTrack}
            orderId={order._id}
            trackingLink={order.easypost_tracking_url}
          >
            <View margin="xxs">
              <OrderLinkText
                canTip={canTip}
                canTrack={canTrack}
                order={order}
              />
            </View>
          </OrderLink>
        </div>
      </div>
    </View>
  );
}

function OrderLink({ children, canTip, canTrack, orderId, trackingLink }) {
  if (canTip) return <a href={`/tip/${orderId}`}>{children}</a>;

  if (canTrack) {
    const href = trackingLink ? trackingLink : `/tracking/${orderId}`;
    return <a href={href}>{children}</a>;
  }

  return (
    <Link to={`/orders/${orderId}`}>
      {children}
      <Text display secondary size="xs">
        View Details
      </Text>
    </Link>
  );
}

function OrderLinkText({ canTip, canTrack, order }) {
  const isReturned = isReturnedOrder(order);
  const isCanceled = isCanceledOrder(order) || isFailedOrder(order);

  const text = canTip
    ? 'Rate & Tip'
    : canTrack
      ? 'Track Order'
      : isReturned ? 'Returned' : isCanceled ? 'Canceled' : orderTotal(order);

  let textProps = {
    display: true,
    weight: 'med',
    size: 'xs'
  };

  if (canTip || canTrack) textProps.success = true;
  if (isCanceled || isReturned) textProps.error = true;

  return <Text {...textProps}>{text}</Text>;
}
